/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {DataAutomationPipeline} from './DataAutomationPipeline';

/**
 * The InlineResponse20117 model module.
 * @module model/InlineResponse20117
 * @version 1.0.0
 */
export class InlineResponse20117 {
  /**
   * Constructs a new <code>InlineResponse20117</code>.
   * @alias module:model/InlineResponse20117
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse20117</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20117} obj Optional instance to populate.
   * @return {module:model/InlineResponse20117} The populated <code>InlineResponse20117</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20117();
      if (data.hasOwnProperty('data'))
        obj.data = DataAutomationPipeline.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {module:model/DataAutomationPipeline} data
 */
InlineResponse20117.prototype.data = undefined;

